

export default 
    {
        "yatequiero.com" : {
            company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH"
        },
        "localhost":{
            company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH",
            iframes:{
                it:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY'></iframe>`,
                es:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY?zf_lang=en'></iframe>`,
                en:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY?zf_lang=en'></iframe>`,
            },
        },
        "staging.yatequiero.com":{
            company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH"
        },
        "placerbonito.com" : {
            company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH"
        },
        "jammydate.com":{
           company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH"
        },
        "looviing.com":{
            company:"Ganko Media Sagl - Via Canova, 9 - 6900 Lugano CH"
        },
        "pay.flirtincontri.com":{
           company:"Iumob srl - Via Comelico, 3, 20135 Milano",
           iframes:{
                it:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY'></iframe>`,
                es:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
                en:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
            },

           
        },
        "pay.incontrisenzafreni.com":{
           company:"Iumob srl - Via Comelico, 3, 20135 Milano",
           iframes:{
                it:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY'></iframe>`,
                es:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
                en:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
            },

           
        },
        "pay.positiveflirt.com":{
           company:"Iumob srl - Via Comelico, 3, 20135 Milano",
           iframes:{
                it:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/FormcontattiDescriptorsmultilingua/formperma/ZYyCmPsqYES5W1uM1y3dS5gswdN7V5YwDFnsGDxsvoY'></iframe>`,
                es:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
                en:`<iframe aria-label='Form contatti Descriptors multilingua' frameborder="0" style="height:100%;width:99%;border:none;" src='https://forms.zohopublic.eu/support160/form/IUMOBMultiDescriptorsENG/formperma/pNgk08TWfp7CTGtDi-JQdGIM04YGJQncSJohJ51jbu0'></iframe>`,
            },

           
        },
    }